import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo, SilentRequest } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import {
  catchError,
  concatMap, forkJoin, Observable, switchMap, tap, throwError
} from 'rxjs';
import { TokenState, UserInfo } from '../../models/auth.model';
import { USE_CUSTOM_TOKEN } from '../constants/context-token';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthService {
  readonly $authState = signal<AccountInfo | null>(null);
  readonly $fabricToken = signal<TokenState | null>(null);
  readonly $isAuthenticated = signal<boolean>(false);
  readonly $isAdmin = computed<boolean>(() => (this.$userInfo() != null ? this.$userInfo()?.isAdmin! : false));
  readonly $msaltoken = signal<TokenState | null>(null);
  readonly $userInfo = signal<UserInfo | null>(null);

  constructor(
    private msalService: MsalService,
    private http: HttpClient
  ) {}

  // getRESTApiAccessToken(username: string) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/x-www-form-urlencoded',
  //   });

  //   let body = new HttpParams();
  //   body = body.set('grant_type', 'password');
  //   body = body.set('username', username);
  //   body = body.set('password', environment.api.secretKey);
  //   body = body.set('TenantId', environment.api.tenantId);
  //   return this.http.post(API_ENDPOINTS.TOKEN_ENDPOINT, body.toString(), {
  //     headers,
  //   });
  // }

  setAuthDetais(authState: AccountInfo) {
    this.$authState.set(authState);
    this.$isAuthenticated.set(true);
  }

  logoff() {
    this.msalService.logout();
  }

  getUserInfo(): Observable<UserInfo> {
    const url = API_ENDPOINTS.USER_INFO;
    return this.http.get<UserInfo>(url);
  }

  getmsalTokenforScope(isFabricScope: boolean = false) {
    const scopes = isFabricScope ? [...environment.fabric.scopes] : [...environment.msal.scopes];
    const request: SilentRequest = {
      scopes: scopes,
      account: this.msalService.instance.getActiveAccount()!,
    };
    return this.msalService.acquireTokenSilent(request).pipe(
      catchError(error => {
        if (error.name === 'InteractionRequiredAuthError') {
          return this.msalService.acquireTokenPopup(request);
        }
        return throwError(() => error);
      })
    );
  }

  // getTokenAndUserDetails(email: string) {
  //   return this.getRESTApiAccessToken(email).pipe(
  //     concatMap((res: any) => {
  //       const tokenState: TokenState = {
  //         token: res.access_token,
  //         expTime: this.getTokenExpTime(res.expires_in),
  //       };
  //       this.$tokenState.set(tokenState);
  //       return this.getUserInfo();
  //     })
  //   );
  // }

  getmsalTokenAndUserDetails() {
    return this.getmsalTokenforScope().pipe(
      concatMap((resp: any) => {
        const tokenState: TokenState = {
          token: resp.accessToken,
          expTime: resp.expiresOn!,
        };
        this.$msaltoken.set(tokenState);
        return this.getUserInfo();
      })
    );
  }

  getmsalTokensWithDiffScopes() {
    const reqObsFirst = this.getmsalTokenforScope();
    const reqObsSecond = this.getmsalTokenforScope(true);
    return forkJoin([reqObsFirst, reqObsSecond]).pipe(
      switchMap(([respMsalToken, respFabricToken]) => {
        if (respMsalToken) {
          const tokenState: TokenState = {
            token: respMsalToken.accessToken,
            expTime: respMsalToken.expiresOn!,
          };
          this.$msaltoken.set(tokenState);
        }
        if (respFabricToken) {
          const tokenState: TokenState = {
            token: respFabricToken.accessToken,
            expTime: respFabricToken.expiresOn!,
          };
          this.$fabricToken.set(tokenState);
        }
        return this.getUserInfo();
      })
    );
  }

  getTokenExpTime(expires_in: number) {
    const currentTime = new Date();
    currentTime.setMinutes(currentTime.getMinutes() + expires_in);
    return currentTime;
  }

  // Add this method to retrieve the secret from the backend
  fetchDirectlineSecret(): Observable<string> {
    const url = API_ENDPOINTS.KeyVault_Secret;
    const params = new HttpParams().set('secretName', 'chatbotDirectlineSecret');

    return this.http.get<{ secretName: string, secretValue: string }>(url, { params }).pipe(
      map(response => response.secretValue),
      catchError(error => {
        console.error('Error fetching Direct Line secret:', error);
        return throwError(error); // Ensure you return a proper Observable or handle error accordingly
      })
    );
  }

  getDirectlineToken(){

    // const url = "https://europe.directline.botframework.com/v3/directline/tokens/generate";
    // const secret = (window as any).directLineSecret;
    // const context = new HttpContext().set(USE_CUSTOM_TOKEN, secret);
    // return this.http.post(url, null, { context : context})
    // First fetch the secret
    return this.fetchDirectlineSecret().pipe(
      switchMap(secret => {
        //const tokenUrl = "https://europe.directline.botframework.com/v3/directline/tokens/generate";
        const tokenUrl = "https://directline.botframework.com/v3/directline/tokens/generate";
        const headers = new HttpHeaders().set('Authorization', `Bearer ${secret}`);
        return this.http.post(tokenUrl, null, { headers });
      })
    );
  }
  
}
